import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "main main-studentSpace comprehensiveQuality"
};
const _hoisted_2 = {
  key: 0,
  class: "title_name"
};
const _hoisted_3 = {
  key: 0,
  t: "1688699821371",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "9139",
  width: "2.5rem",
  height: "2.5rem"
};
const _hoisted_4 = {
  key: 1,
  t: "1688699861340",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "11152",
  width: "2.5rem",
  height: "2.5rem"
};
const _hoisted_5 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_6 = {
  style: {
    "margin-right": "14px"
  }
};
const _hoisted_7 = {
  style: {
    "margin-right": "14px",
    "margin-left": "16px"
  }
};
const _hoisted_8 = {
  class: "con"
};
const _hoisted_9 = {
  class: "con-Data"
};
const _hoisted_10 = {
  class: "table"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  colspan: "3",
  class: "t_body_header"
};
const _hoisted_13 = ["rowspan"];
const _hoisted_14 = ["isRed"];
const _hoisted_15 = {
  class: "con-Data"
};
const _hoisted_16 = {
  class: "con-Data"
};
const _hoisted_17 = {
  class: "box"
};
const _hoisted_18 = {
  class: "stuInfoBor"
};
const _hoisted_19 = {
  class: "table-tit"
};
const _hoisted_20 = {
  class: "stuInfo"
};
const _hoisted_21 = {
  style: {
    "background-color": "rgba(68, 157, 254, 0.1)"
  }
};
const _hoisted_22 = {
  class: "con-Data"
};
const _hoisted_23 = {
  class: "con-Data"
};
const _hoisted_24 = {
  class: "footer-box"
};
const _hoisted_25 = {
  class: "teacher-omments"
};
const _hoisted_26 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "space-around"
  }
};
const _hoisted_27 = {
  style: {
    "text-align": "left",
    "padding": "14px 30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_ConfigTable = _resolveComponent("ConfigTable");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.studentData ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.studentData.sex == '男' ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[2] || (_cache[2] = [_createElementVNode("path", {
    d: "M512 105.3c-220.7 0-399.7 179-399.7 399.7s179 399.7 399.7 399.7 399.7-179 399.7-399.7-179-399.7-399.7-399.7z m241.6 270.8h-0.5v175.4h-99.8v-90.1l-46.6 49.7c13.7 27.1 21.4 57.6 21.4 90 0 110.4-89.5 200-199.9 200s-199.9-89.5-199.9-200 89.5-200 199.9-200c36.1 0 70.1 9.6 99.3 26.4l48.3-51.4h-97.5v-99.7h275.3v99.7z",
    fill: "#0091FF",
    "p-id": "9140"
  }, null, -1), _createElementVNode("path", {
    d: "M428 501.5c-55.1 0-99.7 44.8-99.7 100s44.6 100 99.7 100 99.7-44.8 99.7-100-44.7-100-99.7-100z",
    fill: "#0091FF",
    "p-id": "9141"
  }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
    d: "M512 105.5c-220.6 0-399.5 178.9-399.5 399.5S291.4 904.5 512 904.5 911.5 725.6 911.5 505 732.6 105.5 512 105.5z m200 621.9H561.5v75.1h-99.1v-75.1H312V627.3h150.4v-6.2c-33.6-8.6-65.5-25.9-91.8-52.2-78-78-78-204.5 0-282.5s204.5-78 282.5 0 78 204.5 0 282.5c-26.3 26.3-58.1 43.7-91.7 52.2v6.2h150.4v100.1h0.2z",
    fill: "#FF4D94",
    "p-id": "11153"
  }, null, -1), _createElementVNode("path", {
    d: "M582.4 356.1c-39.1-39.1-102.5-39.1-141.6 0-39.1 39.1-39.1 102.4 0 141.5 39.1 39.1 102.5 39.1 141.6 0 39.1-39 39.1-102.4 0-141.5z",
    fill: "#FF4D94",
    "p-id": "11154"
  }, null, -1)]))])), _createElementVNode("span", null, _toDisplayString($props.studentData.studentName), 1)])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[4] || (_cache[4] = _createElementVNode("label", {
    class: "label",
    style: {
      "margin-right": "14px"
    }
  }, "学年", -1)), _createVNode(_component_el_select, {
    modelValue: $data.listQuery.schoolYear,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.listQuery.schoolYear = $event),
    onChange: $options.changeYear,
    placeholder: "请选择学年",
    size: "small"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_7, [_cache[5] || (_cache[5] = _createElementVNode("label", {
    class: "label",
    style: {
      "margin-right": "14px"
    }
  }, "学期", -1)), _createVNode(_component_el_select, {
    modelValue: $data.listQuery.schoolTerm,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.listQuery.schoolTerm = $event),
    onChange: $options.query,
    placeholder: "请选择学期",
    size: "small"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options2, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    class: "marl15",
    onClick: $options.studentQualityBtn
  }, {
    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("导出", -1)]))]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[9] || (_cache[9] = _createElementVNode("h2", null, "一、综合素养", -1)), _createElementVNode("table", _hoisted_10, [_cache[8] || (_cache[8] = _createElementVNode("tr", {
    class: "table-t"
  }, [_createElementVNode("td", null, "类别"), _createElementVNode("td", null, "项目"), _createElementVNode("td", null, "是否达标")], -1)), !$data.ca.length ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [...(_cache[7] || (_cache[7] = [_createElementVNode("tr", null, [_createElementVNode("td", {
    colspan: "3",
    style: {
      "text-align": "center"
    }
  }, "占无数据")], -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.ca, (item, index) => {
    return _openBlock(), _createElementBlock("tbody", {
      key: index
    }, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_12, _toDisplayString(item.classTitle), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (v, i) => {
      return _openBlock(), _createElementBlock("tr", {
        class: "t_body_item",
        key: i
      }, [i == 0 ? (_openBlock(), _createElementBlock("td", {
        key: 0,
        rowspan: item.children.length
      }, _toDisplayString(v.itemTitle), 9, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("td", null, _toDisplayString(v.title), 1), _createElementVNode("td", {
        isRed: v.state
      }, _toDisplayString(v.state), 9, _hoisted_14)]);
    }), 128))]);
  }), 128))])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("h2", {
    style: _normalizeStyle({
      marginBottom: $data.grade > 2 ? '16px' : '0'
    })
  }, " 二、学业水平 ", 4), _createElementVNode("div", null, [_createVNode(_component_ConfigTable, {
    ref: "configTable",
    "table-data": $data.tableGrade,
    isBorder: true,
    rowClass: true
  }, null, 8, ["table-data"])]), _createElementVNode("div", {
    class: "box gradeTable",
    style: _normalizeStyle({
      marginTop: $data.grade > 2 ? '-27px' : '0'
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.XYSP, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", {
      class: "table-tit table-bom",
      style: _normalizeStyle({
        backgroundColor: index % 2 != 0 ? '#fff' : '',
        borderTop: index == 0 ? '1px solid rgba(64, 158, 255, 0.4)' : ''
      })
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", null, _toDisplayString(item.score), 1)], 4)]);
  }), 128))], 4)]), _createElementVNode("div", _hoisted_16, [_cache[17] || (_cache[17] = _createElementVNode("h2", null, "三、身心健康", -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[12] || (_cache[12] = _createElementVNode("span", null, "身体素质", -1)), _createElementVNode("span", null, [_cache[10] || (_cache[10] = _createTextVNode("总分：", -1)), _createElementVNode("span", null, _toDisplayString($data.infoData.finalScore), 1)]), _createElementVNode("span", null, [_cache[11] || (_cache[11] = _createTextVNode("等级：", -1)), _createElementVNode("span", null, _toDisplayString($data.infoData.level), 1)])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", null, [_cache[13] || (_cache[13] = _createElementVNode("span", null, "身高（厘米）：", -1)), _createElementVNode("span", null, _toDisplayString($data.infoData.height), 1)]), _createElementVNode("p", null, [_cache[14] || (_cache[14] = _createElementVNode("span", null, "体重（千克）：", -1)), _createElementVNode("span", null, _toDisplayString($data.infoData.weight), 1)]), _createElementVNode("p", null, [_cache[15] || (_cache[15] = _createElementVNode("span", null, "视力（左）：", -1)), _createElementVNode("span", {
    class: _normalizeClass({
      perfect: $data.infoData.leftVisionLevel == '正常' ? true : false,
      blue: $data.infoData.leftVisionLevel == '轻度视力低下' ? true : false,
      Munde: $data.infoData.leftVisionLevel == '中度视力低下' ? true : false,
      red: $data.infoData.leftVisionLevel == '重度视力低下' ? true : false
    })
  }, _toDisplayString($data.infoData.leftVisionValue) + _toDisplayString($data.infoData.leftVisionLevel ? "（" + $data.infoData.leftVisionLevel + "）" : ""), 3)]), _createElementVNode("p", _hoisted_21, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "视力（右）：", -1)), _createElementVNode("span", {
    class: _normalizeClass({
      perfect: $data.infoData.rightVisionLevel == '正常' ? true : false,
      blue: $data.infoData.rightVisionLevel == '轻度视力低下' ? true : false,
      Munde: $data.infoData.rightVisionLevel == '中度视力低下' ? true : false,
      red: $data.infoData.rightVisionLevel == '重度视力低下' ? true : false
    })
  }, _toDisplayString($data.infoData.rightVisionValue) + _toDisplayString($data.infoData.rightVisionLevel ? "（" + $data.infoData.rightVisionLevel + "）" : ""), 3)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.infoData.physicalCategoryScoreInfoVoList, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      key: index,
      style: _normalizeStyle({
        backgroundColor: Math.ceil((index + 2) / 3) % 2 == 1 ? 'rgba(68, 157, 254, 0.1)' : ''
      })
    }, [_createElementVNode("span", null, _toDisplayString(item.categoryName) + _toDisplayString(item.unit ? "（" + item.unit + "）" : "") + "：", 1), _createElementVNode("span", {
      class: _normalizeClass({
        perfect: item.levelCode == 1 ? true : false,
        green: item.levelCode == 2 ? true : false,
        blue: item.levelCode == 3 ? true : false,
        red: item.levelCode == 4 ? true : false
      })
    }, _toDisplayString(item.value) + _toDisplayString(item.level ? "（" + item.level + "）" : ""), 3)], 4);
  }), 128)), ($data.infoData.physicalCategoryScoreInfoVoList.length + 1) % 3 == 1 ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    style: _normalizeStyle({
      backgroundColor: Math.ceil(($data.infoData.physicalCategoryScoreInfoVoList.length + 1) / 3) % 2 == 1 ? 'rgba(68, 157, 254, 0.1)' : ''
    })
  }, null, 4)) : _createCommentVNode("", true), ($data.infoData.physicalCategoryScoreInfoVoList.length + 1) % 3 == 1 || ($data.infoData.physicalCategoryScoreInfoVoList.length + 1) % 3 == 2 ? (_openBlock(), _createElementBlock("p", {
    key: 1,
    style: _normalizeStyle({
      backgroundColor: Math.ceil(($data.infoData.physicalCategoryScoreInfoVoList.length + 1) / 3) % 2 == 1 ? 'rgba(68, 157, 254, 0.1)' : ''
    })
  }, null, 4)) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.SXJK, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", {
      class: "table-tit table-bom",
      style: _normalizeStyle({
        backgroundColor: index % 2 != 0 ? '#fff' : ''
      })
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", null, _toDisplayString(item.score), 1)], 4)]);
  }), 128))])])]), _createElementVNode("div", _hoisted_22, [_cache[18] || (_cache[18] = _createElementVNode("h2", null, "四、学生荣誉", -1)), _createElementVNode("div", null, [_createVNode(_component_ConfigTable, {
    ref: "configTable",
    "table-data": $data.sius,
    isBorder: true,
    rowClass: true
  }, null, 8, ["table-data"])])]), _createElementVNode("div", _hoisted_23, [_cache[19] || (_cache[19] = _createElementVNode("h2", null, "五、教师寄语", -1)), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tec, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "omments-list",
      key: index
    }, [_createElementVNode("p", _hoisted_26, _toDisplayString(item.commentName), 1), _createElementVNode("p", _hoisted_27, _toDisplayString(item.commentText), 1)]);
  }), 128))])])])])]);
}